// extracted by mini-css-extract-plugin
var _1 = "ActionsCell_editCardButton__Rc-jz";
var _2 = "ActionsCell_iconEditCardButton__79Ajl";
var _3 = "ActionsCell_popupWrapper__0ugeQ";
export { _1 as "editCardButton", _2 as "iconEditCardButton", _3 as "popupWrapper" }
